import { EventEmitter, Injectable } from "@angular/core";
import { CartoService } from "./carto.service";
import { environment } from "../../environments/environment";

export enum MatchStatus {
  NotStarted = 0,
  Quarter1 = 1,
  Break = 2,
  Quarter2 = 3,
  Quarter3 = 4,
  Quarter4 = 5,
  Finished = 7,
  Suspended = 8,
  Postponed = 9,
  Overtime = 10,
  Cancelled = 100,
}

export interface IEvent {
  event_id: number;
  zone_id: number;
  player_id: number;
  quarter: number;
  failures: number;
  faults: number;
  points: number;
  shots: number;
  time: number;
  x: number;
  y: number;
  team_0: number;
  player_0_id: number;
  player_1_id: number;
  score_home: number;
  score_visitor: number;
}

@Injectable()
export class MatchService extends CartoService {
  ENV_PREFIX = environment.carto.envPrefix;
  TIMER_SECONDS = 22;
  matchStart: number;
  timer: any;
  finished: boolean = false;
  private refreshEventSource = new EventEmitter<any>();
  refreshEvent$ = this.refreshEventSource.asObservable();

  // We use Carto Named Sources as way to hidden querries. More info https://docs.carto.com/carto-user-manual/developers/named-sources
  getGame(gameId: number): Promise<any> {
    const q = `${this.ENV_PREFIX}fetch_game`;
    let params;
    let headerParams;
    let now = Date.now();
    if (this.matchStart - now < 0 && !this.finished) {
      params = `{"gameId":${gameId}}`; // , "ts":${Date.now() - (Date.now() % 1e4)}
      headerParams = { "Cache-Control": "max-age=20, no-cache" };
    } else {
      params = `{"gameId":${gameId}}`; // , "ts":${Date.now() - (Date.now() % 1e7)}
      headerParams = { "Cache-Control": "max-age=300" };
    }
    return this.queryData(q, params, headerParams);
  }

  getGameEvents(
    gameId: number,
    sinceId: number = 0,
    lastEvent: number = 0
  ): Promise<IEvent[]> {
    if (!this.matchStart || this.matchStart - Date.now() > 0) {
      return Promise.resolve([]);
    }
    const q = `${this.ENV_PREFIX}fetch_game_events`;
    let params;
    let headerParams;

    // If the match is finished, we don't need to get the events
    // If it is live we use the Cache-Control of 10 seconds to avoid unnecessary requests
    if (this.finished) {
      params = `{"gameId":${gameId}, "partitionId":${Number(
        gameId.toString().slice(-4)
      )}, "status":7, "sinceId":0, "lastEvent":${lastEvent}}`;
      headerParams = {};
    } else {
      params = `{"gameId":${gameId}, "partitionId":${Number(
        gameId.toString().slice(-4)
      )}, "sinceId":${sinceId} }`;

      headerParams = { "Cache-Control": "max-age=20, no-cache" };
    }
    return this.queryData(q, params, headerParams);
  }

  getGameStats(gameId: number, lastStat: number = 0): Promise<any[]> {
    if (!this.matchStart || this.matchStart - Date.now() > 0) {
      return Promise.resolve([]);
    }
    const q = `${this.ENV_PREFIX}fetch_game_stats`;
    let params;
    let headerParams;

    // If the match is finished, we don't need to get the stats
    // If it is live we use the Cache-Control of 10 seconds to avoid unnecessary requests
    if (this.finished) {
      params = `{"gameId":${gameId}, "partitionId":${Number(
        gameId.toString().slice(-4)
      )}, "status":7, "lastStat":${lastStat}}`;
      headerParams = {};
    } else {
      params = `{"gameId":${gameId}, "partitionId":${Number(
        gameId.toString().slice(-4)
      )}}`;
      headerParams = { "Cache-Control": "max-age=20, no-cache" };
    }
    return this.queryData(q, params, headerParams);
  }

  startTimer() {
    if (!this.timer) {
      const a = Date.now();
      if (this.matchStart - a > 0) {
        // The match has not started yet
        const timerSeconds = (this.matchStart - Date.now()) / 1000;
        setTimeout(() => {
          this.startTimerWithMatch();
        }, timerSeconds * 1000);
      } else {
        this.startTimerWithMatch();
      }
    }
  }
  startTimerWithMatch() {
    this.timer = setInterval(() => {
      this.refreshEventSource.next(null);
    }, this.TIMER_SECONDS * 1000);
  }

  stopTimer() {
    clearInterval(this.timer);
    this.timer = null;
  }

  getTeamImg({ code, id }) {
    // return `${environment.teamAssetsUrl}/${code.toLowerCase()}-${id}/badge.png`;
    return `${environment.teamUrl}/${id}.app.png?$General$&wid=144&hei=144`; // 86
  }

  getPlayerImg(team, playerId) {
    //return `${environment.teamAssetsUrl}/${team.code.toLowerCase()}-${team.id}/${playerId}.jpg`;
    return `${environment.playerUrl}/${playerId}.jpg?$General$&wid=102&hei=102`; //620
  }
}
